import { Component, Input, Output, EventEmitter, OnInit, OnDestroy, OnChanges, SimpleChanges, inject, ChangeDetectorRef, NgZone } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-success-notification-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './success-notification-card.component.html',
  styleUrls: ['./success-notification-card.component.scss']
})
export class SuccessNotificationCardComponent implements OnInit, OnDestroy, OnChanges {
  private cdr = inject(ChangeDetectorRef);
  
  @Input() show: boolean = false;
  @Input() title: string = '¡Cambios guardados!';
  @Input() subtitle: string = 'La acción se realizó con éxito';
  @Input() autoDismissTime: number = 3000; // Tiempo en ms para cierre automático
  @Input() showProgress: boolean = true; // Mostrar barra de progreso
  
  @Output() close = new EventEmitter<void>();
  
  progressValue: number = 0;
  private progressInterval?: number;
  private dismissTimeout?: number;

  ngOnInit(): void {
    if (this.show && this.autoDismissTime > 0) {
      this.startProgress();
      this.setAutoDismissTimer();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['show']?.currentValue && !changes['show']?.previousValue && this.autoDismissTime > 0) {
      // show cambió de false a true - reiniciar completamente
      this.clearTimers();
      this.progressValue = 0;
      
      // Usar setTimeout para evitar problemas de timing
      setTimeout(() => {
        this.startProgress();
        this.setAutoDismissTimer();
        this.cdr.markForCheck();
      }, 50);
    } else if (!changes['show']?.currentValue && changes['show']?.previousValue) {
      // show cambió de true a false
      this.clearTimers();
      this.progressValue = 0;
    }
  }

  ngOnDestroy(): void {
    this.clearTimers();
  }

  onClose(): void {
    this.clearTimers();
    this.close.emit();
    this.cdr.markForCheck();
  }

  private startProgress(): void {
    if (!this.showProgress || this.autoDismissTime <= 0) {
      return;
    }
    
    const interval = 16; // 60fps para animación suave
    const totalSteps = Math.floor(this.autoDismissTime / interval);
    const step = 100 / totalSteps;
    
    this.progressValue = 0; // Empezar desde 0%
    let currentStep = 0;
    
    this.progressInterval = window.setInterval(() => {
      currentStep++;
      this.progressValue = Math.min((currentStep * step), 100);
      
      if (currentStep >= totalSteps || this.progressValue >= 100) {
        this.progressValue = 100;
        this.clearProgressInterval();
      }
      this.cdr.markForCheck();
    }, interval);
  }

  private setAutoDismissTimer(): void {
    this.dismissTimeout = window.setTimeout(() => {
      this.onClose();
    }, this.autoDismissTime);
  }

  private clearTimers(): void {
    this.clearProgressInterval();
    
    if (this.dismissTimeout) {
      clearTimeout(this.dismissTimeout);
      this.dismissTimeout = undefined;
    }
  }
  
  private clearProgressInterval(): void {
    if (this.progressInterval) {
      clearInterval(this.progressInterval);
      this.progressInterval = undefined;
    }
  }
}